<template>
  <div>
    <div class="form-check ms-2" v-for="option in options" :key="option.id">
      <input
        class="form-check-input"
        type="checkbox"
        :name="fieldName"
        v-model="myValue"
        :value="option.id"
      />
      <label class="form-check-label" :for="option.id">
        {{ option.name }}
      </label>
    </div>
  </div>
</template>

<script>
import formComponent from "./formComponent";

export default {
  name: "FormCheckBoxList",
  mixins: [formComponent],
  props: {
    fieldValue: {
      type: Array,
      default: false,
    },
    fieldName: {
      type: [String, Number, Array],
      default: null,
    },
    fieldLabel: {
      type: String,
      default: "",
    },
    isRequired: {
      type: Boolean,
      default: true,
    },
    tooltipInfo: {
      type: String,
      default: null,
    },
    options: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      myValue: "",
    };
  },
};
</script>
